interface IPictogram {
  icon: string;
  name: string;
}

export const pictograms: IPictogram[] = [
  { icon: "02_pict_book.png", name: "Book" },
  { icon: "03_pict_raised_fist.png", name: "Raised fist" },
  { icon: "04_pict_hand_with_heart.png", name: "Hand with heart" },
  { icon: "05_pict_hand_waving.png", name: "Hand waving" },
  { icon: "06_pict_shooting_star.png", name: "Shooting star" },
  { icon: "07_pict_australia.png", name: "Australia" },
  { icon: "08_pict_trophy.png", name: "Trophy" },
  { icon: "09_pict_speech_bubbles.png", name: "Speech bubbles" },
  { icon: "10_pict_pencil_and_book.png", name: "Pencil and book" },
  { icon: "11_pict_shoe.png", name: "Shoe" },
  { icon: "12_pict_arrow.png", name: "Arrow" },
  { icon: "13_pict_lightbulb.png", name: "Lightbulb" },
  { icon: "14_pict_paper_with_tick.png", name: "Paper with tick" },
  { icon: "15_pict_peace_sign.png", name: "Peace sign" },
  { icon: "16_pict_heart.png", name: "Heart" },
  { icon: "17_pict_collaboration.png", name: "Collaboration" },
  { icon: "18_pict_thumbs_up.png", name: "Thumbs up" },
  { icon: "19_pict_pencil.png", name: "Pencil" },
  { icon: "20_pict_music_notes.png", name: "Music notes" },
  { icon: "21_pict_people.png", name: "People in a group" },
  { icon: "22_pict_macquarie.png", name: "Macquarie building" },
  { icon: "23_pict_pointing_hand.png", name: "Pointing Hand" },
  { icon: "24_pict_cochlear_implant.png", name: "Cochlear Implant" },
];

pictograms.sort((a: IPictogram, b: IPictogram) => {
  if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
  else return 1;
});

export const getPictogramFileByName = (name: string): string | undefined => {
  return pictograms.find((p) => p.name === name)?.icon || undefined;
};
